import React from "react";
import { useTranslation } from "react-i18next";
import Input from "../../../../../components/Input";
import { VALIDATION_FIELD_MAPPING } from "../../../../../utils/appConstant";
import { Validation } from "../../../../../interfaces/common";
import { CommissionSettings } from "../../../../../interfaces/user.interface";

interface SetupTabProps {
  formData: CommissionSettings;
  validation: Validation;
  view?: boolean;
  onInputChange: (e: any, name: string) => void;
  onInputBlur: (e: any, name: string) => void;
  onKeyDown: (e: any, name?: string) => void;
}

interface CommissionFieldProps {
  field: keyof CommissionSettings;
  i18nKey: string;
  value: string;
  validation: Validation;
  view?: boolean;
  onInputChange: (e: any, name: string) => void;
  onInputBlur: (e: any, name: string) => void;
  onKeyDown: (e: any, name?: string) => void;
}

const CommissionField: React.FC<CommissionFieldProps> = ({
  field, i18nKey, value, validation, view, onInputChange, onInputBlur, onKeyDown
}) => {
  const { t } = useTranslation();
  const fieldName = VALIDATION_FIELD_MAPPING[field];
  const fieldError = validation.fields.find((f) => f.field === fieldName);

  return (
    <div className="col-md-4">
      <div className="form-floating form-floating-outline">
        <Input
          type="text"
          id={fieldName}
          name={fieldName}
          disabled={view}
          error={!!fieldError}
          errorMessage={fieldError?.message ?? ''}
          label={t(`users.addEdit.pageTexts.form.setup.${i18nKey}.label`)}
          placeholder={t(`users.addEdit.pageTexts.form.setup.${i18nKey}.placeholder`)}
          value={value}
          onKeyDown={onKeyDown}
          onBlur={e => onInputBlur(e, fieldName)}
          onChange={e => onInputChange(e, fieldName)}
        />
      </div>
    </div>
  );
};

const SetupTab: React.FC<SetupTabProps> = ({
  formData, validation, view, onInputChange, onInputBlur, onKeyDown
}) => {
  const { t } = useTranslation();

  return (
    <div className="card-body">
      <div className="row g-6">
        <h6 className="mb-0">{t("users.addEdit.pageTexts.form.setup.sectionTitle")}</h6>

        <CommissionField
          field="baseCommissionPercentage"
          i18nKey="baseCommission"
          value={formData.baseCommissionPercentage}
          validation={validation}
          view={view}
          onInputChange={onInputChange}
          onInputBlur={onInputBlur}
          onKeyDown={onKeyDown}
        />

        <CommissionField
          field="propertyVisitCommissionPercentage"
          i18nKey="propertyVisitCommission"
          value={formData.propertyVisitCommissionPercentage}
          validation={validation}
          view={view}
          onInputChange={onInputChange}
          onInputBlur={onInputBlur}
          onKeyDown={onKeyDown}
        />

        <CommissionField
          field="transactionSharingPercentage"
          i18nKey="transactionSharing"
          value={formData.transactionSharingPercentage}
          validation={validation}
          view={view}
          onInputChange={onInputChange}
          onInputBlur={onInputBlur}
          onKeyDown={onKeyDown}
        />

        <p className="text-muted mb-0">{t("users.addEdit.pageTexts.form.setup.note")}</p>
      </div>
    </div>
  )
};

export default SetupTab;
